<template>
  <div class="container" :class="{'video-loaded': videoLoaded}">
    <div v-if="!!selectedArticle" class="overlay" ref="overlay">
      <expandable-article :article="selectedArticle" :top="`${articleOffset.top}px`" :class="{expanded: preloadArticle}"
                          :height="`${articleOffset.height}px`" @closed="closeArticle" :show-date="false"/>
    </div>
    <section class="section intro">
      <div class="background">
        <video src="./../assets/images/wherewework.webm" muted autoplay ref="background-video"></video>
      </div>
      <div class="content">
        <p class="section-header" v-html="$translations.get('where_we_work_header')">Our mark on the world</p>
        <p class="section-title" v-html="$translations.get('where_we_work_title')">Where we work</p>
        <p class="section-text" v-html="$translations.get('where_we_work_text')">
          Wagner - Hatfield works everywhere around the world, no matter where the challenge is we are here to help.
          Read
          more bellow to see what we have helped our clients with around the world
        </p>
      </div>
    </section>
    <section class="section challenges">
      <div class="content">
        <router-link :to="`/where-we-work/${article.Slug}`" v-for="(article, index) in articles" class="challenge-item" :key="index"
                     @click="selectArticle(index)" ref="article">
          <div class="background">
            <img :src="`https://wagner-hatfield.com/administration/upload/article/${article.Image}`" alt="background"/>
          </div>
          <p class="title-header">{{article.ShortDescription}}</p>
          <p class="title">{{article.Title}}</p>
          <a class="read-more" v-html="$translations.get('read_more')"></a>
        </router-link>
      </div>
    </section>
    <footer-section :background="require('./../assets/images/wherewework_footer.png')"/>
  </div>
</template>

<script>
  import FooterSection from "@/components/FooterSection";
  import ExpandableArticle from "@/components/ExpandableArticle";

  export default {
    name: 'WhereWeWork',
    metaInfo: {
      title: "Where we work"
    },
    components: {ExpandableArticle, FooterSection},
    props: {
      articles: {
        type: Array
      }
    },
    data: () => ({
      preloadArticle: false,
      videoLoaded: false,
      selectedArticle: null,
      articleOffset: {
        top: 0,
        height: 0
      },
    }),
    beforeRouteUpdate(to, from, next) {
      let slug = to.params["slug"];
      if (slug) {
        this.selectSlug(slug);
      }
      next();
    },
    methods: {
      getOffset: function (el) {
        let rect = el.getBoundingClientRect(),
          scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
          scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {top: rect.top}
      },
      selectSlug: function (slug, scroll) {
        let articleIndex = this.articles.findIndex((element) => element.Slug === slug);
        if (articleIndex >= 0) {
          if (scroll) {
            this.$refs["article"][articleIndex].$el.scrollIntoView();
          }
          this.selectArticle(articleIndex);
        }
      },
      selectArticle: function (index) {
        let el = this.$refs["article"][index].$el;
        let offset = this.getOffset(el);
        this.articleOffset = {
          top: offset.top,
          height: el.offsetHeight
        };
        this.selectedArticle = this.articles[index];
        this.$emit('scrollbar-visibility', false);
      },
      closeArticle: function () {
        this.selectedArticle = null;
        this.$emit('scrollbar-visibility', true);
      }
    },
    mounted: function () {
      let slug = this.$route.params["slug"];
      if (slug) {
        this.videoLoaded = true;
        this.preloadArticle = true;
        this.$refs["background-video"].currentTime = 3;
        this.selectSlug(slug, true);
      } else {
        let interval = setInterval(() => {
          let video = this.$refs["background-video"];
          if (video && video.currentTime >= 3) {
            this.videoLoaded = true;
            clearInterval(interval);
          }
        }, 1000);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../static/css/style';

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 20;
    overflow-y: scroll;
  }

  .section {

    &.intro {

      .content {
        height: 100vh;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        flex-direction: column;
        padding-left: 4rem;
        padding-bottom: 4rem;
        box-sizing: border-box;

        .section-header {
          text-align: left !important;
          opacity: 0;
        }

        .section-title {
          text-align: left !important;
          opacity: 0;
        }

        .section-text {
          text-align: left !important;
          opacity: 0;
          max-width: 50vw !important;
        }
      }
    }

    &.challenges {

      .content {

        .challenge-item {
          position: relative;
          display: block;
          padding: 2rem 4rem;
          cursor: pointer;
          text-decoration: none;

          .background {
            background: #000;
            @include absolute-stretch();

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              object-position: center;
              opacity: 0.2;
              z-index: 2;
              @include transition(opacity $default-ease 500ms);
            }
          }

          .title-header {
            position: relative;
            text-transform: uppercase;
            font-size: 0.7rem;
            font-family: 'OpenSans-Bold', sans-serif;
            color: #fff;
            margin: 0;
            z-index: 3;
          }

          .title {
            position: relative;
            font-size: 2.5rem;
            color: #fff;
            margin: 0.6vw 0;
            font-family: 'OpenSans-Bold', sans-serif;
            z-index: 3;
          }

          .read-more {
            position: relative;
            text-transform: uppercase;
            font-size: 0.7rem;
            font-family: 'OpenSans-Bold', sans-serif;
            color: $accent-color;
            margin: 0;
            opacity: 0.2;
            padding: 0.3em;
            @include transition(opacity $default-ease 500ms);
            z-index: 3;

            &::after {
              content: '';
              display: block;
              position: absolute;
              left: 50%;
              bottom: 0;
              width: 0;
              height: 0.1rem;
              background: $accent-color;
              @include transition(width $default-ease 500ms, left $default-ease 500ms);
            }
          }

          &:hover {

            .background img {
              opacity: 0.6;
            }

            .read-more {
              opacity: 1;

              &::after {
                left: 0;
                width: 100%;
              }
            }
          }
        }
      }
    }

    @include media-query(medium) {

      &.intro {

        .content {
          justify-content: center;
          align-items: center;
          padding-left: 0;
          padding-bottom: 0;

          .section-header {
            text-align: center !important;
          }

          .section-title {
            text-align: center !important;
          }

          .section-text {
            text-align: center !important;
            max-width: 90vw !important;
          }
        }
      }

      &.challenges {

        .content {

          .challenge-item {
            padding: 1rem 3rem;

            .title {
              font-size: 1.5rem;
            }
          }
        }
      }
    }
  }

  .footer {

    .content {
      display: none;
    }
  }

  .video-loaded {

    .intro {

      .section-header {
        @include animation(fadeIn 1s $default-ease 0s 1 forwards);
      }

      .section-title {
        @include animation(fadeIn 1s $default-ease 200ms 1 forwards);
      }

      .section-text {
        @include animation(fadeIn 1s $default-ease 400ms 1 forwards);
      }
    }
  }
</style>
